import {
    POSTAL_CHANNEL_T1_NAVIGATION,
    POSTAL_TOPIC_PRIMARY_NAV_HIDE,
    POSTAL_TOPIC_PRIMARY_NAV_SHOW,
} from "../../../../common-deprecated/constants";
import { postalPublish } from "../../../../common-deprecated/utils/postalUtils";

export const triggerHeader = (isHidden: boolean): void => {
    if (!isHidden) {
        postalPublish({
            channel: POSTAL_CHANNEL_T1_NAVIGATION,
            topic: POSTAL_TOPIC_PRIMARY_NAV_SHOW,
        });
    } else if (isHidden) {
        postalPublish({
            channel: POSTAL_CHANNEL_T1_NAVIGATION,
            topic: POSTAL_TOPIC_PRIMARY_NAV_HIDE,
        });
    }
};
